import React, { useEffect, useRef, useState, useCallback } from "react";
import "./styles/main.css";
import ChatInput from "./components/ChatInput";
import Header from "./components/Header";
import Loader from "components/Loader";
import Icon from "components/Icon";
import Convo from "./components/Convo";
import { useCurrentUserContext } from "context/currentUserContext";
import { useChatsContext } from "context/chatsContext";
import ScrollToBottom, {
  useScrollToBottom,
  useSticky
} from "react-scroll-to-bottom";
import ImageGallery from "react-image-gallery";
import "../../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import { getAttachmentUrl } from "../../utils/formatChatData";

import { useDispatch, useSelector } from "react-redux";
import { loadChats } from "stores/chats/chats";
import { loadChatInfo } from "stores/chats/chatInfo";
import { loadCannedResponses } from "stores/chats/cannedResponses";
import { loadChatConfigurations } from "stores/chats/chatConfigurations";
import { loadBusinessHoursChatPermission } from "stores/chats/chatConfigurations";
import { updateChatReadStatus } from "stores/chats/chats";
import { wsconnect, wssend } from "stores/socket";
import { toast } from "react-toastify";
import { viewFor } from "utils/constants";
import ChatImageSlider from "./components/ChatImageSlider";
import { useLocation } from "react-router-dom";
import ChatLoader from "components/ChatLoader";
import axios from "axios";

const ConvoScrollContent = (props) => {
  const scrollToBottom = useScrollToBottom();
  const [sticky] = useSticky();
  const dispatch = useDispatch();
  const callInProgress = useRef(false);
  const hasLoadedOldestChat = useRef(false);
  const [didReachTop, setDidReachTop] = useState(false);
  const [unseenMsgCount, setUnseenMsgCount] = useState(0);
  const [scrolledDown, setScrolledDown] = useState(false);

  useEffect(() => {
    const chatContainer = document.querySelector(".chat__content");
    chatContainer.scrollTop = chatContainer.scrollHeight;
  }, []);

  useEffect(() => {
    const chatId = props.chatId;
    const chatContainer = document.querySelector(".chat__content");

    const cb = (e) => {
      if (callInProgress.current) return;

      // if (e.target.scrollTop <= 0.3 * e.target.scrollHeight) {
      if (e.target.scrollTop === 0) {
        callInProgress.current = true;

        let allMessages = [];

        let dates = Object.keys(props.messages);
        dates = dates.reverse();

        dates.map((date, dateIndex) => {
          let messages = props.messages[date];
          messages = messages.slice().reverse();
          allMessages = [...allMessages, ...messages];
        });

        let timeStamp = allMessages[0].timeStamp;
        let chatId = props.chatId;
        let id = allMessages[0].messageId;
        new Promise((resolve, reject) => {
          setDidReachTop(true);
          dispatch(
            loadChats({
              chatId,
              timeStamp,
              resolve,
              reject
              // userId: props.currentUser.id,
              // userType: props.currentUser.type
            })
          );
        })
          .then((data) => {
            chatContainer.removeEventListener("scroll", cb);

            if (chatContainer.scrollTop === 0) {
              document.getElementById(id).style.scrollMargin = "55px";
              document.getElementById(id).scrollIntoView(true);
            }

            if (!Object.keys(data.chats).length) {
              hasLoadedOldestChat.current = true;
            }
          })
          .catch(() => {
            setDidReachTop(false);
            toast.error("Error in loading older chats. Please refresh");
          })
          .finally(() => {
            setDidReachTop(false);
            callInProgress.current = false;
          });
      }
    };

    if (!hasLoadedOldestChat.current) {
      chatContainer.addEventListener("scroll", cb);
    }

    return () => {
      chatContainer.removeEventListener("scroll", cb);
    };
  }, [props.messages]);

  const chatContainer = document.querySelector(".chat__content");

  return (
    <>
      {didReachTop ? (
        <div style={{ textAlign: "center" }}>Loading...</div>
      ) : null}
      <Convo
        {...props}
        markMessageAsRead={props.markMessageAsRead}
        onImageClick={props.onImageClick}
        setUnseenMsgCount={setUnseenMsgCount}
        unseenMsgCount={unseenMsgCount}
        setScrolledDown={setScrolledDown}
        scrolledDown={scrolledDown}
        botName={props?.botName}
      />
      {!sticky && (
        <>
          {unseenMsgCount && !scrolledDown ? (
            <p className="unseenCount">
              {unseenMsgCount < 9 ? unseenMsgCount : "9+"}
            </p>
          ) : null}
          <button
            className="chat__scroll-btn"
            aria-label="scroll down"
            onClick={() => {
              setScrolledDown(true);
              setUnseenMsgCount(0);
              scrollToBottom();
            }}
          >
            <Icon id="doubleDownArrow" />
          </button>
        </>
      )}
    </>
  );
};

const ImagesViewer = ({ activeImageId, handleClose }) => {
  const chatsData = useSelector((state) => {
    return state.chatReducer;
  });
  const attachments = chatsData.attachments;
  const images = attachments.images;
  let curIndex = 0;

  const formattedImages = images.map((cur, index) => {
    if (cur.messageId === activeImageId) {
      curIndex = index;
    }
    return {
      original: getAttachmentUrl(cur.attchUrl)
    };
  });
  if (!formattedImages.length) {
    return null;
  }
  return (
    <div className="chat__image-gallery-wrapper">
      <ImageGallery
        items={formattedImages}
        showFullscreenButton={false}
        showThumbnails={false}
        lazyLoad
        showNav={false}
        showPlayButton={false}
        startIndex={curIndex}
        infinite={false}
      />
      <div className="chat__image-gallery-icon-wrapper" onClick={handleClose}>
        <Icon id="closeIcon" />
      </div>
    </div>
  );
};

const Chat = ({ match, history, chatId, ...props }) => {
  const { currentUser, setCurrentUser } = useCurrentUserContext();
  const dispatch = useDispatch();
  const [isFeedbackSession, setIsFeedbackSession] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const sliderConfig = useSelector(
    (state) => state?.chatReducer?.chatSliderConfig
  );
  const [newMessage, setNewMessage] = useState("");

  const { search } = useLocation();

  const isAgent = viewFor === "agent" ? true : false;

  //Initial Load
  useEffect(() => {
    setShowLoader(true);

    // if (!currentUser || !chatId) {
    if (!chatId) {
      return;
    }

    const userId = currentUser?.id;

    const loadChatsPromise = new Promise((resolve, reject) => {
      dispatch(
        loadChats({
          chatId,
          resolve,
          reject
          // userId: currentUser.id,
          // userType: currentUser.type
        })
      );
    });
    const loadChatInfoPromise = new Promise((resolve, reject) => {
      dispatch(
        loadChatInfo({
          chatId,
          // userId: currentUser.id,
          // userType: currentUser.type,
          resolve,
          reject
        })
      );
    });

    if (isAgent) {
      var loadChatConfigurationsPromise = new Promise((resolve, reject) => {
        dispatch(loadChatConfigurations({ chatId, resolve, reject }));
      });
      var loadBusinessHoursChatPermissionPromise = new Promise(
        (resolve, reject) => {
          dispatch(
            loadBusinessHoursChatPermission({ chatId, resolve, reject })
          );
        }
      );
      // var loadCannedResponsesPromise = new Promise((resolve, reject) => {
      //   dispatch(loadCannedResponses({ userId, resolve, reject }));
      // });
    }

    dispatch(wsconnect({ chatId, currentUser }));

    let allPromises = [loadChatsPromise, loadChatInfoPromise];

    if (isAgent) {
      allPromises = allPromises.concat(
        ...[
          loadChatConfigurationsPromise,
          loadBusinessHoursChatPermissionPromise
          // loadCannedResponsesPromise
        ]
      );
    }

    let chatData;
    Promise.all(allPromises)
      .then((data) => {
        const chatInfo = data[1];
        chatData = data[1]
        if (viewFor === "user") {
          setCurrentUser({
            name: chatInfo?.user?.name || "",
            id: chatInfo?.user?.customerId || "",
            type: viewFor
          });
        } else if (viewFor === "agent") {
          return;
        } else {
          setCurrentUser({
            name: viewFor,
            id: -1,
            type: viewFor
          });
        }
      })
      .catch((e) => {
        toast.error("Error in loading data, please try again later");
      })
      .finally(() => {
        setShowLoader(false);
          if(chatData?.botName === "makeo_buddy" && viewFor === "user"){
            syncChat(1);
            setInterval(function() {
                syncChat(1);
              }, 15000);
          }
      });
  }, [chatId]);

  useEffect(() => {
    const cb = (event) => {
      // const data = JSON.parse(event.data);
      const data = event.data;
      if (data.type === "fetchMessages" && data.currentActiveChat === chatId) {
        dispatch(
          loadChats({
            chatId: chatId
            // user: currentUser.id,
            // userType: currentUser.type
          })
        );
      }

      if (data?.type === "agentMessage" && isAgent) {
        setNewMessage(data.agentMessage);
      }
      // else if(data.type === 'wsreconnect') {
      //   dispatch(wsconnect({chatId, currentUser}));
      // }
    };

    window.addEventListener("message", cb);

    return () => {
      window.removeEventListener("message", cb);
    };
  }, [chatId, currentUser]);

  const chatsData = useSelector((state) => {
    return state.chatReducer;
  });
  const chats = chatsData.chats;
  const chatInfo = useSelector((state) => {
    return state.chatInfoReducer;
  });
  const cannedResponses = useSelector((state) => {
    return state.cannedResponsesReducer.cannedResponses;
  });
  const chatBusinessConfig = useSelector((state) => {
    return state.chatConfigurationsReducer;
  });

  useEffect(() => {
    if (isAgent && chatInfo) {
      window.parent.postMessage(
        {
          type: "agentDetails",
          info: chatInfo.chatInitiatorAgent
        },
        "*"
      );
      window.parent.postMessage(
        {
          type: "chatDetails",
          info: chatInfo
        },
        "*"
      );
    }
  }, [isAgent, chatInfo]);

  const updateReadReciept = useCallback(
    (messageId) => {
      dispatch(
        updateChatReadStatus({
          messageIds: [messageId],
          chatId: chatId,
          readTstamps: [new Date().toISOString()],
          readerId: currentUser.id.toString(),
          readerType: viewFor
        })
      );
    },
    [currentUser]
  );

  const addNewMessage = async (chat) => {
    dispatch(
      wssend(
        JSON.stringify({
          action: "addNewMessage",
          data: {
            chatId: chatId,
            chat: chat
          }
        })
      )
    );
  };

  const syncChat = async (status) =>{
  const postData = {chatId: chatId, status: status, botName: 'makeo_buddy'}

  // Define custom headers
  const customHeaders = {
    'Content-Type': 'application/json',
  };

  // Define the URL for the POST request
  const postUrl = '/api/v2/chatapp/chat-notification/sync-status';

  // Make a POST request using Axios with custom headers
  axios.post(postUrl, postData, {
    headers: customHeaders, // Include the custom headers in the request
  })
    .then(response => {
      console.log('syncChat success->',response)
    })
    .catch(error => {
      console.log('syncChat error->',error)
    });
  }

  const [showAttach, setShowAttach] = useState(false);
  const [activeImageId, setActiveImageId] = useState(null);
  const [showImageViewer, toggleImageViewer] = useState(false);
  const [showKeyboardLockPopup, setShowKeyboardLockPopup] = useState(false);
  const onImageClick = useCallback((imageId) => {
    setActiveImageId(imageId);
    toggleImageViewer(true);
  }, []);

  if (!currentUser) {
    if (viewFor !== "user") {
      return <div className="widget-loader">Loading...</div>;
    }
    return null;
  }

  if (currentUser && viewFor === "user") {
    const message = JSON.stringify({
      key: "hideLoader"
    });
    window.parent.postMessage(message, "*");
  }

  const submitNewMessage = (newMessageObj) => {
    if (!newMessageObj || newMessageObj.type === "text") {
      if (!newMessage.trim()) {
        return;
      }
      newMessageObj = {
        senderId: currentUser.id,
        senderType: viewFor,
        msgType: "freeText",
        type: "text",
        content: newMessage,
        timeStamp: new Date().toISOString(),
        msgSource: "WEB"
      };
    } else if (newMessageObj.mediaUrls) {
      newMessageObj = {
        senderId: currentUser.id,
        senderType: viewFor,
        msgType: "freeText",
        type: "text_with_image",
        content: newMessage,
        mediaUrls: newMessageObj?.mediaUrls,
        timeStamp: new Date().toISOString(),
        msgSource: "WEB"
      };
    }
    addNewMessage(newMessageObj);
    setNewMessage("");
  };

  if (showLoader) {
    return <ChatLoader />;
  }

  let noFooteClass = "";
  let noHeaderClass = "";

  if (window.location.search.indexOf("footer=false") > -1) {
    noFooteClass = "no-footer";
  }

  if (window.location.search.indexOf("header=false") > -1) {
    noHeaderClass = "no-header";
  }

  if (window.location.search.indexOf("botName") > -1) {
    var isWidget = true;
  }

  const isMakeoBuddy = chatInfo?.botMode && chatInfo?.botName === "makeo_buddy";
  const hideFooter =
    (chatInfo && chatInfo.status === "CLOSED") ||
    chatInfo?.botName === "smilecare_bot" ||
    isMakeoBuddy ||
    isFeedbackSession;

  return (
    <div className={isWidget ? "chat widget" : "chat"}>
      <div className="chat__body">
        {sliderConfig.isOpen && (
          <ChatImageSlider
            imageUrls={sliderConfig.imageUrls}
            messageId={sliderConfig.messageId}
            messageType={sliderConfig.messageType}
            chatId={chatInfo.chatId}
          />
        )}
        {/* {!isWidget ? <div className="chat__bg"></div> : null} */}
        <Header
          user={
            currentUser?.type === "admin" && chatInfo?.user
              ? chatInfo?.user
              : {}
          }
          chatInfo={chatInfo}
          redirectionOrigin={
            viewFor === "user" &&
            !sliderConfig.isOpen &&
            !chatInfo?.botName === "smilecare_bot"
          }
        />
        <ScrollToBottom
          className={`chat__content-wrapper ${noHeaderClass} ${
            hideFooter ? "no-footer" : ""
          } ${showAttach ? "attachment_open" : ""}`}
          scrollViewClassName={"chat__content"}
          followButtonClassName={"hide-default-button"}
        >
          <ConvoScrollContent
            messages={chats}
            currentUser={currentUser}
            onImageClick={onImageClick}
            markMessageAsRead={updateReadReciept}
            chatId={chatId}
            submitNewMessage={addNewMessage}
            setIsFeedbackSession={setIsFeedbackSession}
            botName={chatInfo?.botName}
          />
        </ScrollToBottom>
        {showImageViewer ? (
          <ImagesViewer
            activeImageId={activeImageId}
            handleClose={() => toggleImageViewer(false)}
          />
        ) : null}
        {showKeyboardLockPopup && (
          <div className="locked_input_popup">
            <div className="popup_header">
              <img className="popup_image" src="/images/Union.svg" />
              <span>attempt callback</span>
            </div>
            <div className="popup_content">
              <p className="popup_para">
                your text response period for this message has expired, kindly
                attempt XX callback before sending a message to the client.
              </p>
            </div>
            <div
              className="popup_button"
              onClick={() => {
                setShowKeyboardLockPopup(false);
              }}
            >
              <button className="popup_button">
                <p style={{ color: "white" }}>close</p>
              </button>
            </div>
          </div>
        )}
        {hideFooter ? (
          <></>
        ) : (
          viewFor !== "transcript" && (
            <footer className={"chat__footer"}>
              <>
                <ChatInput
                  chatId={chatId}
                  showAttach={showAttach}
                  setShowAttach={setShowAttach}
                  newMessage={newMessage}
                  setNewMessage={setNewMessage}
                  submitNewMessage={submitNewMessage}
                  cannedResponses={cannedResponses}
                  chatBusinessConfig={chatBusinessConfig}
                  isAgent={isAgent}
                  setShowKeyboardLockPopup={setShowKeyboardLockPopup}
                  messages={chats}
                />
              </>
            </footer>
          )
        )}
      </div>
    </div>
  );
};

export default Chat;
